<template>
  <form @submit.prevent="handleSubmit">
    <div
      class="bg-white border border-gray-200 rounded-lg transition-colors focus-within:border-primary-400 focus-within:ring-4 focus-within:ring-primary-50"
    >
      <textarea
        ref="input"
        v-model="query"
        rows="3"
        class="sensitive block w-full bg-transparent border-0 px-4 pt-4 pb-2 text-[13px] leading-5 text-gray-900 placeholder:text-gray-500 resize-none focus:ring-0 focus:outline-none"
        data-demo-blur
        placeholder="Ask about engagements, action items, blockers or practice activity"
        :disabled="loading"
        @keydown.enter.meta.prevent="handleSubmit"
        @keydown.enter.ctrl.prevent="handleSubmit"
      ></textarea>
      <div class="flex items-center justify-end gap-4 px-2 pb-2">
        <span v-if="query.length > 900" class="text-[11px]" :class="tooLong ? 'text-red-dark' : 'text-gray-600'">
          {{ tooLong ? 'Too long · ' : '' }}{{ query.length.toLocaleString() }} / 1,000
        </span>
        <button
          type="submit"
          :disabled="!canSubmit || loading"
          class="inline-flex items-center gap-2 px-3 py-2 rounded bg-primary-500 text-white text-[13px] font-medium hover:bg-primary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 disabled:bg-primary-100 disabled:text-primary-700 disabled:cursor-not-allowed transition-colors"
        >
          <svg v-if="loading" class="animate-spin h-3.5 w-3.5" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          {{ loading ? 'Asking' : 'Ask' }}
        </button>
      </div>
    </div>

    <div v-if="!query" class="mt-2 flex flex-wrap gap-2">
      <button
        v-for="example in examples"
        :key="example.label"
        type="button"
        class="px-2 py-1 rounded border border-gray-200 bg-white text-[11px] text-gray-600 hover:border-primary-300 hover:text-primary-800 transition-colors disabled:cursor-not-allowed"
        :title="example.prompt"
        :disabled="loading"
        @click="useExample(example)"
      >
        {{ example.label }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'AnalystQueryForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  data() {
    return {
      query: '',
      examples: [
        { label: 'Open blockers by owner', prompt: 'Write a summary report of all open blockers and overdue action items, grouped by practice and owner' },
        { label: '30-day activity briefing', prompt: 'Create an engagement activity briefing for the last 30 days highlighting which practices need immediate attention' },
        { label: 'Who is stalling this quarter', prompt: 'Analyze engagement trends this quarter and summarize which practices are progressing vs stalling' },
        { label: 'Practice readiness', prompt: 'Build a readiness report showing each practice\'s outstanding items, recent engagement frequency, and recommended next steps' },
      ],
    }
  },
  computed: {
    tooLong() {
      return this.query.length > 1000
    },
    canSubmit() {
      return this.query.trim().length > 0 && !this.tooLong
    },
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit || this.loading) return

      this.$emit('submit', {
        query: this.query.trim(),
      })

      this.query = ''
    },

    useExample(example) {
      this.query = example.prompt
      this.$nextTick(() => this.$refs.input.focus())
    },

    appendQuery(text) {
      this.query = this.query ? this.query + '\n' + text : text
      this.$nextTick(() => this.$refs.input.focus())
    },
  },
}
</script>
